// libs
import cx from 'classnames';
import React, { memo, useMemo, useState } from 'react';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { Checkbox } from '@swiggy-private/dls-web-core/dist/components/Checkbox';
// components
import { Chip } from '@/widgets/Chip';
import MultiSelectBox from '@/components/MultiSelectBox';
// styles
import styles from '../Schedule.module.scss';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
function TimeSlotSelector({ options, mealSlots, setMealSlots, validationMessages, }) {
    const [availableMealSlots, setAvailableMealSlots] = useState(options);
    const selectAllOptions = () => {
        setMealSlots(options.map((option) => option.value));
    };
    const unselectAllOptions = () => {
        setMealSlots([]);
    };
    const onSelectAllClick = (event) => {
        if (event.target.checked) {
            selectAllOptions();
        }
        else {
            unselectAllOptions();
        }
    };
    const areAllOptionSelected = useMemo(() => {
        return mealSlots.length === options.length;
    }, [mealSlots, options]);
    const handleQueryInputChange = (text = '') => {
        const filteredOptions = options.filter((option) => option.key.toLowerCase().includes(text.toLowerCase()));
        setAvailableMealSlots(filteredOptions);
    };
    const renderFunction = (option, _, onClick, className) => {
        const onChange = (e) => {
            onClick(e);
        };
        return (React.createElement("div", { className: cx(styles.option, className) },
            React.createElement(Text, { className: styles.optionText, variant: DlsFontVariants.subheader_S1_Reg, color: DlsColorTokens.text_Med_Emphasis }, option.item.key),
            React.createElement("span", { onMouseDown: onChange },
                React.createElement(Checkbox, { label: "", orientation: "rtl", id: option.id, checked: option.selected }))));
    };
    const onChange = (options) => {
        const mealSlotsValue = options
            .filter((option) => option.selected)
            .map((option) => option.item.value);
        const selectedPreselectedValue = [];
        const selectedValue = [];
        for (const val of mealSlots) {
            const matchedItem = options.find((item) => item.id === val);
            if (matchedItem) {
                matchedItem.selected && selectedPreselectedValue.push(val);
            }
            else {
                selectedPreselectedValue.push(val);
            }
        }
        mealSlotsValue.forEach((option) => {
            const isIncluded = selectedPreselectedValue.includes(option);
            if (!isIncluded) {
                selectedValue.push(option);
            }
        });
        const ids = [...selectedValue, ...selectedPreselectedValue];
        setMealSlots(ids);
    };
    const selectAllLabel = availableMealSlots.length > 1 ? 'meal slots' : 'meal slot';
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", null,
            React.createElement("div", { className: styles.header },
                React.createElement(Text, { variant: DlsFontVariants.subheader_S1_Bold, color: DlsColorTokens.text_High_Emphasis, className: styles.headerTitle }, "Time slots tailored around user meal times"),
                React.createElement(Text, { variant: DlsFontVariants.body_B1_Reg, color: DlsColorTokens.text_Med_Emphasis }, "Your Ad would be shown to users during the time slots selected by you. You time slots would be reflected below")),
            React.createElement("div", { className: styles.preftype },
                React.createElement(Checkbox, { id: "time-slot-select-all", name: "time-slot-select-all", label: "Select all meal slots", checked: areAllOptionSelected, onChange: onSelectAllClick })),
            React.createElement("div", null, mealSlots.map((option) => {
                const currentOption = options.find((opt) => opt.value === option);
                if (!currentOption)
                    return null;
                return (React.createElement(Chip, { key: option, containerClass: styles.selectedOption, label: `${currentOption.key} ${currentOption.timeLabel}`, onActionButtonClick: () => setMealSlots(mealSlots.filter((item) => item !== option)) }));
            }))),
        React.createElement("div", null,
            React.createElement(Text, { variant: DlsFontVariants.header_H5_Bold, color: DlsColorTokens.text_Low_Emphasis, className: styles.dropdownTitle }, "Meal Slots"),
            React.createElement(MultiSelectBox, { placeholder: "Select your meal slots", openOnFocus: true, autoUpdatePosition: true, selectAllLabel: selectAllLabel, renderFunction: renderFunction, onChange: onChange, values: mealSlots, options: availableMealSlots, inputErrorText: validationMessages.mealSlots, identifier: (item) => item.value, onInputTextChange: handleQueryInputChange }))));
}
export default memo(TimeSlotSelector);
